import TRIP_STATUSES from './../config/trip.constant';
import DELIVERY_TYPES from './../../ukrail/delivery-options-types';

export default function TripItemCancellationService(
    $stateParams,
    tripAPI,
    tripItemCancellationMessageService
) {
    'ngInject';

    Object.assign(this, {
        getForm,
        isTripItemCancellable,
        isTripItemCancellation,
        isTripCancellation,
        areCostsMayBeIncurred,
        isNonRefundableBooking,
        isNoChargeForCancelling,
        hideCancellationForm,
        isTripItemConfirmed,
        isTripConfirmed,
        cancelTripItem,
        ticketsReturnIsRequiredForRefund,
    });

    function cancelTripItem(cancellation, cancellationForm) {
        const {cancellationItemMsg: {item}} = cancellation;
        const {bookingComMessage} = cancellationForm;
        const formData = findFormData(item.id, item.type, cancellation);

        const payload = {
            tripId: +$stateParams.id,
            tripItemId: item.id,
            tripItemType: item.type,
            supplierOptions: formData,
        };
        if (bookingComMessage) {
            Object.assign(payload, {CancellationReason: bookingComMessage});
        }
        return tripAPI.cancelTripItem(payload)
            .then(({data}) => {
                const status = data.CancelStatus;
                tripItemCancellationMessageService.addCancellationMessage(cancellation, formData, status);
                hideCancellationForm(cancellation);
            });
    }

    function getForm(cancellation, model, type) {
        if (!cancellation.forms) {
            cancellation.forms = [];
        }

        const form = cancellation.forms.find((item) => model.Id === item.id && type === item.type);
        if (form) {
            return form;
        }

        const newForm = {
            id: model.Id,
            type,
            item: model,
            isFormValid: true,
            data: {},
        };
        cancellation.forms.push(newForm);
        return newForm;
    }

    function isTripItemCancellable(cancellation) {
        const {cancellationItemMsg} = cancellation;
        return !isTripCancellation(cancellation)
            && cancellationItemMsg.item
            && cancellationItemMsg.item.id;
    }

    function isTripItemCancellation(cancellation) {
        const {cancellationItemMsg} = cancellation;
        return cancellationItemMsg
            && cancellationItemMsg.item
            && cancellationItemMsg.message;
    }

    function isTripCancellation(cancellation) {
        const {cancellationMsg} = cancellation;
        return !!cancellationMsg.message;
    }

    function areCostsMayBeIncurred(cancellation) {
        const {cancellationItemMsg} = cancellation;
        return cancellationItemMsg.confirmed
            && cancellationItemMsg.isRefundable;
    }

    function isNonRefundableBooking(cancellation) {
        const {cancellationItemMsg} = cancellation;
        return cancellationItemMsg.confirmed
            && !cancellationItemMsg.isRefundable;
    }

    function isNoChargeForCancelling(cancellation) {
        return cancellation.cancellationItemMsg.quote;
    }

    function hideCancellationForm(cancellation) {
        cancellation.cancellationItemMsg = {};
    }

    function findFormData(id, type, cancellation) {
        const form = cancellation.forms.find((value) => value.id === id && value.type === type);
        if (!form) {
            return {};
        }
        return form.data;
    }

    function isTripItemConfirmed(model) {
        return model.Status === TRIP_STATUSES.TRIP_STATUSES.CONFIRMED;
    }

    function isTripConfirmed(cancellation) {
        const {cancellationMsg} = cancellation;
        return !cancellationMsg.quote;
    }

    function ticketsReturnIsRequiredForRefund(model) {
        const itemDeliveryType = model && model.DeliveryType;
        if (!itemDeliveryType) {
            return false;
        }

        const deliveryTypes = [
            DELIVERY_TYPES.KIOSK,
            DELIVERY_TYPES.POST,
            DELIVERY_TYPES.SAMEDAY,
            DELIVERY_TYPES.NEXTDAY,
            DELIVERY_TYPES.COLLECTION,
            DELIVERY_TYPES.CORPORATEKIOSK,
            DELIVERY_TYPES.SAMEDAYOFFICEDROP,
        ];

        return deliveryTypes
            .map(({typeName}) => typeName)
            .includes(itemDeliveryType);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation/trip-item-cancellation-service.js